import * as Yup from "yup";

export const autosaveFiltersSchema = Yup.object().shape({
  timerValue: Yup.number().min(15, "Timer value must be at least 15 seconds").required("Timer value is required"),
});
